import { useState, useEffect, useCallback } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

import { parse } from "papaparse";
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

import TEXT from "../../../utils/text/surveys_national.json";

// RENAMED: Added _COL suffix to avoid matching with Mexico.js
async function getColombiaCsvData(url) {
  const data = parse(await fetchColombiaCsv(url), { header: true });
  return data.data;
}
// RENAMED: Added _COL suffix
async function fetchColombiaCsv(url) {
  const responseCol = await fetch(url);
  const readerCol = responseCol.body.getReader();
  const resultCol = await readerCol.read();
  const decoderCol = new TextDecoder("utf-8");
  const csvCol = await decoderCol.decode(resultCol.value);
  return csvCol;
}

export default function Colombia({ survey }) {
  const { language } = useCurrentLanguage();
  const [colombiaData, setData] = useState([]);
  const [colombiaQuestions, setQuestions] = useState([]);

  const handleColombiaData = useCallback(async () => {
    const processGroupedBarData_COL = (csvData) => {
      const y_axis = Object.keys(csvData[0]).filter((e) => e !== "Afirmacion");
      const x_axis = csvData.map((e) => e["Afirmacion"]);
      const series = y_axis.map((e, i) => {
        return x_axis.map((el) =>
          Number(csvData.find((e) => e["Afirmacion"] === el)[y_axis[i]])
        );
      });
      return [y_axis, x_axis, series];
    };

    const col_csv1 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p1.csv`
    );
    const col_csv2 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p2.csv`
    );
    const col_csv3 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p3.csv`
    );
    const col_csv5 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p5.csv`
    );
    const col_csv6 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p6.csv`
    );
    const col_csv7 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p7.csv`
    );
    const col_csv8 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p8.csv`
    );
    const col_csv9 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p9.csv`
    );
    const col_csv10 = await getColombiaCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}colombia_p10.csv`
    );

    let col_data1 = [
      col_csv1.map((e) => e["Emoción"]),
      col_csv1.map((e) => Number(e["Porcentaje"])),
    ];
    let col_data2 = [
      col_csv2.map((e) => e["Fecha"]),
      col_csv2.map((e) =>
        Number(e[language === "en" ? "Favourable" : "Favorable"])
      ),
      col_csv2.map((e) =>
        Number(e[language === "en" ? "Unfavourable" : "Desfavorable"])
      ),
    ];
    let col_data3 = [
      col_csv3.map((e) => e["Fecha"]),
      col_csv3.map((e) =>
        Number(e[language === "en" ? "Favourable" : "Favorable"])
      ),
      col_csv3.map((e) =>
        Number(e[language === "en" ? "Unfavourable" : "Desfavorable"])
      ),
    ];

    const y_data_col5 = Object.keys(col_csv5[0]).filter(
      (e) => e !== "categoria"
    );
    let col_data5 = [
      col_csv5.map((e) => e["categoria"]),
      Object.keys(col_csv5[0]).filter((e) => e !== "categoria"),
      [
        y_data_col5.map((e) => Number(col_csv5[0][e])),
        y_data_col5.map((e) => Number(col_csv5[1][e])),
        y_data_col5.map((e) => Number(col_csv5[2][e])),
      ],
    ];

    const col_data6 = processGroupedBarData_COL(col_csv6);
    const col_data7 = processGroupedBarData_COL(col_csv7);

    const y_data8 = Object.keys(col_csv8[0]).filter((e) => e !== "Afirmacion");
    const x_data8 = col_csv8.map((e) => e["Afirmacion"]);
    const series8 = y_data8.map((e, i) => {
      return x_data8.map((el) =>
        Number(col_csv8.find((e) => e["Afirmacion"] === el)[y_data8[i]])
      );
    });
    const data8 = [y_data8, x_data8, series8];

    const y_data9 = Object.keys(col_csv9[0]).filter((e) => e !== "Afirmacion");
    const x_data9 = col_csv9.map((e) => e["Afirmacion"]);
    const series9 = y_data9.map((e, i) => {
      return x_data9.map((el) =>
        Number(col_csv9.find((e) => e["Afirmacion"] === el)[y_data9[i]])
      );
    });
    const data9 = [y_data9, x_data9, series9];

    const y_data10 = Object.keys(col_csv10[0]).filter(
      (e) => e !== "Afirmacion"
    );
    const x_data10 = col_csv10.map((e) => e["Afirmacion"]);
    const series10 = y_data10.map((e, i) => {
      return x_data10.map((el) =>
        Number(col_csv10.find((e) => e["Afirmacion"] === el)[y_data10[i]])
      );
    });
    const data10 = [y_data10, x_data10, series10];

    let colombiaSurveyObjects = [
      {
        id: "q1",
        question: TEXT["COL"]["q1"]["question"][language],
        source: TEXT["COL"]["q1"]["source"][language],
        description: TEXT["COL"]["q1"]["description"][language],
        narrative: TEXT["COL"]["q1"]["narrative"][language],
        data: col_data1,
        rotate: true,
        graphType: "bar",
        hasOptions: false,
        survey: TEXT["COL"]["q1"]["survey"][language],
        link: TEXT["COL"]["q1"]["link"],
      },
      {
        id: "q2",
        question: TEXT["COL"]["q2"]["question"][language],
        source: TEXT["COL"]["q2"]["source"][language],
        description: TEXT["COL"]["q2"]["description"][language],
        narrative: TEXT["COL"]["q2"]["narrative"][language],
        data: col_data2,
        graphType: "line",
        hasOptions: false,
        survey: TEXT["COL"]["q2"]["survey"][language],
        link: TEXT["COL"]["q2"]["link"],
      },
      {
        id: "q3",
        question: TEXT["COL"]["q3"]["question"][language],
        source: TEXT["COL"]["q3"]["source"][language],
        description: TEXT["COL"]["q3"]["description"][language],
        narrative: TEXT["COL"]["q3"]["narrative"][language],
        data: col_data3,
        graphType: "line",
        hasOptions: false,
        survey: TEXT["COL"]["q3"]["survey"][language],
        link: TEXT["COL"]["q3"]["link"],
      },
      {
        id: "q5",
        question: TEXT["COL"]["q5"]["question"][language],
        source: TEXT["COL"]["q5"]["source"][language],
        description: TEXT["COL"]["q5"]["description"][language],
        narrative: TEXT["COL"]["q5"]["narrative"][language],
        data: col_data5,
        graphType: "s_h_bar",
        hasOptions: false,
        isLarge: true,
        survey: TEXT["COL"]["q5"]["survey"][language],
        link: TEXT["COL"]["q5"]["link"],
      },
      {
        id: "q6",
        question: TEXT["COL"]["q6"]["question"][language],
        source: TEXT["COL"]["q6"]["source"][language],
        description: TEXT["COL"]["q6"]["description"][language],
        narrative: TEXT["COL"]["q6"]["narrative"][language],
        data: col_data6,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["COL"]["q6"]["survey"][language],
        link: TEXT["COL"]["q6"]["link"],
      },
      {
        id: "q7",
        question: TEXT["COL"]["q7"]["question"][language],
        source: TEXT["COL"]["q7"]["source"][language],
        description: TEXT["COL"]["q7"]["description"][language],
        narrative: TEXT["COL"]["q7"]["narrative"][language],
        data: col_data7,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["COL"]["q7"]["survey"][language],
        link: TEXT["COL"]["q7"]["link"],
      },
      {
        id: "q8",
        question: TEXT["COL"]["q8"]["question"][language],
        source: TEXT["COL"]["q8"]["source"][language],
        description: TEXT["COL"]["q8"]["description"][language],
        data: data8,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["COL"]["q8"]["survey"][language],
        link: TEXT["COL"]["q8"]["link"],
      },
      {
        id: "q9",
        question: TEXT["COL"]["q9"]["question"][language],
        source: TEXT["COL"]["q9"]["source"][language],
        description: TEXT["COL"]["q9"]["description"][language],
        data: data9,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["COL"]["q9"]["survey"][language],
        link: TEXT["COL"]["q9"]["link"],
      },
      {
        id: "q10",
        question: TEXT["COL"]["q10"]["question"][language],
        source: TEXT["COL"]["q10"]["source"][language],
        description: TEXT["COL"]["q10"]["description"][language],
        data: data10,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["COL"]["q10"]["survey"][language],
        link: TEXT["COL"]["q10"]["link"],
      },
    ];

    let colombiaQuestionList = [];
    colombiaSurveyObjects.forEach((e) => {
      if (e.survey === survey)
        colombiaQuestionList.push({ code: e.id, label: e.question });
    });

    setData(colombiaSurveyObjects.filter((el) => el.survey === survey));
    setQuestions(colombiaQuestionList);
  }, [language, survey]); // Dependencies for useCallback

  useEffect(() => {
    if (survey !== "") handleColombiaData();
  }, [survey, handleColombiaData]);

  return (
    <div>
      <SurveyNational
        data={colombiaData} // Pass the state variable
        questions={colombiaQuestions} // Pass the state variable
        title={survey}
      />
    </div>
  );
}
